import React from "react";
import { BrowserRouter, Switch, Route, Redirect } from "react-router-dom";
import {
  Login,
  Home,
  Carteira,
  ClienteDetalhe,
  Pedido,
  PedidoDetalhe,
  Comissao,
  AbcCliente,
  AbcProduto,
  Orcamento,
  OrcamentoDetalhe,
  Configuracao,
  ConsultaInteligente,
  Programacao,
  ProgramacaoNova,
  ProgramacaoLista,
  ProgramacaoCopia,
  RelatorioAgenda,
  PedidoNovo,
  PedidoInfo,
  NewClient,
  HistoricoVenda,
  ProdutoDestaque,
  ProdutoDetalhe,
  Carrinho,
  AdicionarItem,
  PedidoRevisao,
  EnderecoEditar,
  ProdutoDestaque1,
  AgendaNova,
  AgendaEditar,
  AgendaDetalhe,
  TituloAtraso,
  NovoUsuario,
  NovoUsuario1,
  Usuario,
  Impressao,
  VisualizadorDanfe,
  Perfil,
  PerfilNovo,
  HistoricoVendaCapa,
  Dashboard,
  MetaUsuario,
  Empresa,
  MetaEmpresa,
} from "./pages";
import { isAuthenticated, getToken, getUser } from "./auth";
import NavBar from "./components/NavBar";
import SideBar from "./components/SideBar";
import { ToastProvider } from "react-awesome-toasts";
require("dotenv").config();

const logout = () => {
  localStorage.removeItem("token");
  localStorage.removeItem("user");
  localStorage.removeItem("imagem");
  window.location.href = `${process.env.REACT_APP_FRONTEND_URL}/login`;
};

const getParametersApi = () => {
  return {
    headers: {
      "x-access-token": getToken(),
    },
  };
};

const getBaseUrlApi = () => {
  let urlAtual = window.location.origin;

  if (urlAtual.search("localhost") !== -1) {
    return process.env.REACT_APP_DEV_API_URL_LOCAL;
  }
  let urlEnv = process.env.REACT_APP_DEV_API_URL.split(":")[1];
  urlEnv = urlEnv.replace("//", "").trim();

  if (urlAtual.search(urlEnv) !== -1) {
    return process.env.REACT_APP_DEV_API_URL;
  } else {
    return process.env.REACT_APP_DEV_API_URL_LOCAL;
  }
};

function getBaseUrlBanco() {
  return process.env.REACT_APP_BANCO_URL;
}

function getUserBanco() {
  return {
    username: process.env.REACT_APP_BANCO_USER,
    password: process.env.REACT_APP_BANCO_PASSWORD
  };
}

function getBaseUrlImpressao() {
  return process.env.REACT_APP_IMPRESSAO_URL;
}

function getBaseUrlBackendHibrido() {
  return process.env.REACT_APP_BACKEND_HIB_URL;
}

const handlingErrorsApi = (error, props) => {
  error = JSON.parse(error);
  let response = error.response;

  if (error.response) {
    if (response.status && response.status === 401) {
      //logout();
      props.history.push("login");
    } else if (response.status && response.status === 422) {
      //logout();
      props.history.push("login");
    } else {
      console.log("error");
    }
  } else {
    console.log(error);

    console.log("fatal error");
  }
};

const detectIE = () => {
  var ua = window.navigator.userAgent;
  var msie = ua.indexOf("MSIE ");
  if (msie > 0) {
    return true;
  }
  var trident = ua.indexOf("Trident/");
  if (trident > 0) {
    return true;
  }
  return false;
};

const PrivateRoute = ({
  component: Component,
  itemActive,
  titulo,
  icone,
  ...rest
}) => {
  if (detectIE()) {
    return (
      <div className="container">
        <div className="row">
          <div
            className="alert alert-warning"
            role="alert"
            style={{ width: "100%" }}
          >
            <p>
              <b>Alerta</b> : a versão do navegador de internet que você está
              utilizando não é suportada por esta aplicação ou é muito antiga.
            </p>
            <p>
              As versões recomendadas são :{" "}
              <a
                href="https://www.google.com/intl/pt-BR/chrome/"
                target="_blank"
                className="link-alerta"
              >
                Google Chrome
              </a>{" "}
              e{" "}
              <a
                href="http://www.mozilla.org/pt-BR/firefox/"
                target="_blank"
                className="link-alerta"
              >
                Firefox
              </a>
            </p>
          </div>
        </div>
      </div>
    );
  }

  let listaUrlsPedido = [
    "/pedidos-novo",
    "/pedidos-novo-info",
    "/carrinho",
    "/pedidos-revisao",
    "/adicionar-itens",
    "/enderecos-editar",
    "/produtos/destaque-detalhe",
  ];

  if (listaUrlsPedido.find((item) => item === rest.path) === undefined) {
    localStorage.removeItem("pedido");
    localStorage.removeItem("orcamento");
  }

  return (
    <Route
      {...rest}
      render={(props) =>
        isAuthenticated() ? (
          <div>
            {/* <NavBar titulo={titulo} icone={icone} /> */}
            {/* <SideBar
              itemActive={itemActive}
            /> */}
            <Component
              {...props}
              parameters={getParametersApi}
              user={getUser}
              getBaseUrlApi={getBaseUrlApi}
              handlingErrorsApi={handlingErrorsApi}
              logout={logout}
              getBaseUrlBanco={getBaseUrlBanco}
              getUserBanco={getUserBanco}
              getBaseUrlImpressao={getBaseUrlImpressao}
              getBaseUrlBackendHibrido={getBaseUrlBackendHibrido}
            />
          </div>
        ) : (
          <Redirect
            to={{ pathname: "/login", state: { from: props.location } }}
          />
        )
      }
    />
  );
};

const LoginRoute = ({ component: Component, ...rest }) => {
  if (detectIE()) {
    return (
      <div className="container">
        <div className="row">
          <div
            className="alert alert-warning"
            role="alert"
            style={{ width: "100%" }}
          >
            <p>
              <b>Alerta</b> : a versão do navegador de internet que você está
              utilizando não é suportada por esta aplicação ou é muito antiga.
            </p>
            <p>
              As versões recomendadas são :{" "}
              <a
                href="https://www.google.com/intl/pt-BR/chrome/"
                target="_blank"
                className="link-alerta"
              >
                Google Chrome
              </a>{" "}
              e{" "}
              <a
                href="http://www.mozilla.org/pt-BR/firefox/"
                target="_blank"
                className="link-alerta"
              >
                Firefox
              </a>
            </p>
          </div>
        </div>
      </div>
    );
  }
  return (
    <Route
      {...rest}
      render={(props) =>
        isAuthenticated() ? (
          <Redirect
            to={{ pathname: "/home", state: { from: props.location } }}
          />
        ) : (
          <Component
            {...props}
            parameters={getParametersApi}
            getBaseUrlApi={getBaseUrlApi}
          />
        )
      }
    />
  );
};

const LogoutRoute = ({ component: Component, ...rest }) => {
  logout();
  return (
    <Route
      {...rest}
      render={(props) => (
        <Redirect
          to={{ pathname: "/login", state: { from: props.location } }}
        />
      )}
    />
  );
};

const NoMatch = ({ location }) => (
  <div>
    <center>
      <h3>
        404! <br />
        essa página não existe
      </h3>
    </center>
  </div>
);

const NoPermission = ({ location }) => (
  <div>
    <center>
      <h3>
        403! <br />
        Não Autorizado!
      </h3>
    </center>
  </div>
);

const App = (props) => {
  return (
    <ToastProvider timeout={3000} position={"bottom-left"}>
      <BrowserRouter>
        <Switch>
          <LoginRoute path="/login" exact component={Login} />
          <LogoutRoute path="/logout" exact component={Login} />
          <PrivateRoute
            path="/"
            exact
            component={Home}
            titulo="Indicadores"
            itemActive="indicadores"
            icone="fa-tachometer"
          />
          <PrivateRoute
            path="/home"
            exact
            component={Home}
            titulo="Indicadores"
            itemActive="indicadores"
            icone="fa-tachometer"
          />
          <PrivateRoute
            path="/dashboard"
            exact
            component={Dashboard}
            titulo="Indicadores"
            itemActive="indicadores"
            icone="fa-tachometer"
          />
          <PrivateRoute
            path="/carteira-clientes"
            exact
            component={Carteira}
            titulo="Checklist"
            itemActive="checklist"
            icone="fa-check-square-o"
          />
          <PrivateRoute
            path="/cliente-detalhe"
            exact
            component={ClienteDetalhe}
            titulo="Checklist"
            itemActive="checklist"
            icone="fa-check-square-o"
          />
          <PrivateRoute
            path="/pedidos"
            exact
            component={Pedido}
            titulo="Checklist"
            itemActive="checklist"
            icone="fa-check-square-o"
          />
          <PrivateRoute
            path="/pedido-detalhe"
            exact
            component={PedidoDetalhe}
            titulo="Checklist"
            itemActive="checklist"
            icone="fa-check-square-o"
          />
          <PrivateRoute
            path="/comissao"
            exact
            component={Comissao}
            titulo="Checklist"
            itemActive="checklist"
            icone="fa-check-square-o"
          />
          <PrivateRoute
            path="/agendas"
            exact
            component={RelatorioAgenda}
            titulo="Relatório de agendas"
            itemActive="relatorio-agenda"
            icone="fa-clipboard"
          />
          <PrivateRoute
            path="/consulta-inteligente"
            exact
            component={ConsultaInteligente}
            titulo="Consulta inteligente"
            itemActive="ConsultaInteligente"
            icone="fa-check-square-o"
          />
          <PrivateRoute
            path="/abc-clientes"
            exact
            component={AbcCliente}
            titulo="Checklist"
            itemActive="checklist"
            icone="fa-check-square-o"
          />
          <PrivateRoute
            path="/abc-produtos"
            exact
            component={AbcProduto}
            titulo="Checklist"
            itemActive="checklist"
            icone="fa-check-square-o"
          />
          <PrivateRoute
            path="/orcamentos"
            exact
            component={Orcamento}
            titulo="Checklist"
            itemActive="checklist"
            icone="fa-check-square-o"
          />
          <PrivateRoute
            path="/orcamento-detalhe"
            exact
            component={OrcamentoDetalhe}
            titulo="Checklist"
            itemActive="checklist"
            icone="fa-check-square-o"
          />
          <PrivateRoute
            path="/configuracoes"
            exact
            component={Configuracao}
            titulo="Checklist"
            itemActive="checklist"
            icone="fa-check-square-o"
          />
          <PrivateRoute
            path="/programacao"
            exact
            component={Programacao}
            titulo="Programação"
            itemActive="programacao"
            icone="fa-check-square-o"
          />
          <PrivateRoute
            path="/adicionar-programacao"
            exact
            component={ProgramacaoNova}
            titulo="Adicionar Programação"
            itemActive="programacao"
            icone="fa-check-square-o"
          />
          <PrivateRoute
            path="/lista-programacao"
            exact
            component={ProgramacaoLista}
            titulo="Lista Programação"
            itemActive="programacao"
            icone="fa-check-square-o"
          />
          <PrivateRoute
            path="/copiar-programacao"
            exact
            component={ProgramacaoCopia}
            titulo="Copiar Programação"
            itemActive="programacao"
            icone="fa-check-square-o"
          />

          <PrivateRoute
            path="/pedidos-novo"
            exact
            component={PedidoNovo}
            titulo="Adicionar Programação"
            itemActive="programacao"
            icone="fa-check-square-o"
            action="CADASTRAR"
          />
          <PrivateRoute
            path="/pedidos-novo-info"
            exact
            component={PedidoInfo}
          />
          <PrivateRoute
            path="/pedidos-editar-info"
            exact
            component={PedidoInfo}
          />

          <PrivateRoute
            path="/novoClientes"
            exact
            component={NewClient}
            titulo="NewClient"
            itemActive="newClient"
            icone="fa-check-square-o"
          />
          <PrivateRoute
            path="/historicoVenda"
            exact
            component={HistoricoVenda}
            titulo="historicoVenda"
            itemActive="historicoVenda"
            icone="fa-check-square-o"
          />
          <PrivateRoute
            path="/historico-faturamento-capa"
            exact
            component={HistoricoVendaCapa}
            titulo="historicoVenda"
            itemActive="historicoVenda"
            icone="fa-check-square-o"
          />
          <PrivateRoute
            path="/produtoDestaque"
            exact
            component={ProdutoDestaque}
            titulo="produtoDestaque"
            itemActive="produtoDestaque"
            icone="fa-check-square-o"
          />

          <PrivateRoute
            path="/produtos/destaque-detalhe"
            exact
            component={ProdutoDetalhe}
          />

          <PrivateRoute path="/carrinho" exact component={Carrinho} />

          <PrivateRoute
            path="/adicionar-itens"
            exact
            component={AdicionarItem}
          />

          <PrivateRoute
            path="/pedidos-revisao"
            exact
            component={PedidoRevisao}
            titulo="Adicionar Programação"
            itemActive="programacao"
            icone="fa-check-square-o"
            action="CADASTRAR"
          />
          <PrivateRoute
            path="/enderecos-editar"
            exact
            component={EnderecoEditar}
            titulo="Adicionar Programação"
            itemActive="programacao"
            icone="fa-check-square-o"
            action="CADASTRAR"
          />
          <PrivateRoute
            path="/produtos-destaque"
            exact
            component={ProdutoDestaque1}
            titulo="Adicionar Programação"
            itemActive="programacao"
            icone="fa-check-square-o"
            action="CADASTRAR"
          />
          <PrivateRoute
            path="/agenda-nova"
            exact
            component={AgendaNova}
            titulo="Adicionar Programação"
            itemActive="programacao"
            icone="fa-check-square-o"
            action="CADASTRAR"
          />
          <PrivateRoute
            path="/agenda-editar"
            exact
            component={AgendaEditar}
            titulo="Adicionar Programação"
            itemActive="programacao"
            icone="fa-check-square-o"
            action="EDITAR"
          />
          <PrivateRoute
            path="/agenda-detalhe"
            exact
            component={AgendaDetalhe}
            titulo="Adicionar Programação"
            itemActive="programacao"
            icone="fa-check-square-o"
            action="EDITAR"
          />
          <PrivateRoute
            path="/titulos-atraso"
            exact
            component={TituloAtraso}
            titulo="Adicionar Programação"
            itemActive="programacao"
            icone="fa-check-square-o"
            action="EDITAR"
          />

          <PrivateRoute
            path="/usuarios-novo"
            exact
            component={NovoUsuario1}
            titulo="Adicionar Programação"
            itemActive="programacao"
            icone="fa-check-square-o"
            action="EDITAR"
          />
          <PrivateRoute
            path="/usuarios"
            exact
            component={Usuario}
            titulo="Adicionar Programação"
            itemActive="programacao"
            icone="fa-check-square-o"
            action="EDITAR"
          />
          <PrivateRoute
            path="/usuarios-meta"
            exact
            component={MetaUsuario}
            titulo="Adicionar Programação"
            itemActive="programacao"
            icone="fa-check-square-o"
            action="EDITAR"
          />

<PrivateRoute
            path="/empresas"
            exact
            component={Empresa}
            titulo="Adicionar Programação"
            itemActive="programacao"
            icone="fa-check-square-o"
            action="EDITAR"
          />
<PrivateRoute
            path="/empresas-meta"
            exact
            component={MetaEmpresa}
            titulo="Adicionar Programação"
            itemActive="programacao"
            icone="fa-check-square-o"
            action="EDITAR"
          />


          <PrivateRoute
            path="/impressao"
            exact
            component={Impressao}
            titulo="Impressão"
            itemActive="programacao"
            icone="fa-check-square-o"
            action="EDITAR"
          />
          <PrivateRoute
            path="/visualizador-danfe"
            exact
            component={VisualizadorDanfe}
            titulo="Impressão"
            itemActive="programacao"
            icone="fa-check-square-o"
            action="EDITAR"
          />

          <PrivateRoute
            path="/perfis"
            exact
            component={Perfil}
            titulo="Impressão"
            itemActive="programacao"
            icone="fa-check-square-o"
            action="EDITAR"
          />

          <PrivateRoute
            path="/perfis-novo"
            exact
            component={PerfilNovo}
            titulo="Impressão"
            itemActive="programacao"
            icone="fa-check-square-o"
            action="EDITAR"
          />

          <PrivateRoute
            path="/403"
            exact
            component={NoPermission}
          />

          <Route component={NoMatch} />
        </Switch>
      </BrowserRouter>
    </ToastProvider>
  );
};

export default App;
